export const DEFAULT_API_VERSION = '3.3'

export const controller = 'insights'
export const baseQuery = {
  'api-version': DEFAULT_API_VERSION,
}
